import React from "react";
import BlogFive from "../component/BlogFive";

function BlogFiveContainer() {
  return <BlogFive />;
}
export default BlogFiveContainer;
